import { Component, OnInit } from '@angular/core';
import { DataPointDataType, DynamicComponentBase, IDynamicComponentConfig } from '../../../dynamic-component';

@Component({
  selector: 'app-d-con-fixed-config',
  templateUrl: './d-con-fixed-config.component.html',
  styles: []
})
export class DConFixedConfigComponent extends DynamicComponentBase implements OnInit {
  static KEY = 'd-con-fixed-config';
  dataType = DataPointDataType;
  constructor() {
    super();
  }
  ngOnInit() {
    /** 数据类型设置 */
    this.config.dataType = this.dataType.Fixed;
  }
  configChange(config: IDynamicComponentConfig) {}
}
